import { validationRules } from '@/features/ap_payees/components/DocInstructionMenu/Helpers/validationRules';
import { InstructionEmailForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import {
  ButtonV2,
  FormTextArea,
  IconApproval,
  Label,
  Tooltip,
} from '@moneyforward/ap-frontend-components';
import { FC, RefObject, useMemo } from 'react';
import { Control } from 'react-hook-form';
import styles from '../styles.module.scss';
import { useInstructionContentHandler } from './hook';
import { TextAreaRef } from 'antd/es/input/TextArea';

export type TInstructionContentProps = {
  control: Control<InstructionEmailForm>;
  textAreaRef?: RefObject<TextAreaRef>;
};

export const InstructionContent: FC<TInstructionContentProps> = ({
  control,
  textAreaRef,
}) => {
  const { t } = useTranslation();
  const {
    handleApplyTemplate,
    isTemplateAvailable,
    templateTooltip,
    applyTemplateButtonLabel,
    appliedCustomTemplate,
    tooltipVisible,
  } = useInstructionContentHandler();

  const contentRules = useMemo(
    () => ({
      required: {
        value: true,
        message: t('common.validation.required'),
      },
      validate: validationRules.requiredNotAllowEmpty(
        t('common.validation.required')
      ),
    }),
    [t]
  );
  // text area extend line follow content
  const contentProps = useMemo(
    () => ({
      ref: textAreaRef,
      style: {
        height: 'calc(100vh - 340px)',
        minHeight: '150px',
        lineHeight: '1.5',
        fontSize: '14px',
        fontWeight: 400,
      },
    }),
    [textAreaRef]
  );

  return (
    <>
      <div className={styles.rowContent}>
        <div className={styles.labelContent}>
          <Label text={t('export_instruction_pdf_content')} htmlFor='content' />
        </div>
        <div className={styles['button-template']}>
          <Tooltip
            title={templateTooltip}
            placement='left'
            open={isTemplateAvailable ? tooltipVisible : undefined}
            trigger={!isTemplateAvailable ? ['hover'] : undefined}
          >
            <ButtonV2
              isSecondary
              isTertiary
              leftIcon={appliedCustomTemplate ? <IconApproval /> : undefined}
              onClick={handleApplyTemplate}
              isDisabled={!isTemplateAvailable}
            >
              {applyTemplateButtonLabel}
            </ButtonV2>
          </Tooltip>
        </div>
      </div>
      <div>
        <div className={styles.content}>
          <FormTextArea<InstructionEmailForm>
            name='content'
            control={control}
            inputId='content'
            textAreaProps={contentProps}
            rules={contentRules}
          />
        </div>
      </div>
    </>
  );
};

InstructionContent.displayName = 'InstructionContent';
